import { Button } from "@/components/ui/button";
export default function PolicyProcedure() {
  return <section data-section-id="225538" id="policy-procedure" className="bg-background py-24 md:py-32 px-4 md:px-8 text-foreground">
      <div className="max-w-7xl mx-auto text-center flex flex-col items-center">
        <h2 className="text-4xl md:text-5xl font-default font-bold text-primary mb-6 tracking-tight">
          Departmental Policies & Procedures
        </h2>
        <p className="text-lg md:text-xl font-sans text-muted-foreground max-w-3xl mb-10 leading-relaxed">
          The Metropolitan Central Police Department is committed to transparency and accountability. Access our official protocols, operational manuals, and conduct guidelines to understand how we serve and protect our community.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md font-default font-semibold">
            Browse Policy Library
          </Button>
          <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-accent rounded-md font-default font-semibold">
            Request Public Records
          </Button>
        </div>
      </div>
    </section>;
}